import { useDocumentTitle } from 'usehooks-ts'

export default function usePageTitle(title: string) {
  useDocumentTitle(title)
}
